export const getLowestPackagePrice = (studioCreativesData) => {
    if (!studioCreativesData || !Array.isArray(studioCreativesData) || studioCreativesData.length === 0) {
        return null;
    }

    let lowestPrice = Infinity;
  
    studioCreativesData.forEach((studioCreative) => {
        const creative = studioCreative?.creative;
        if (!creative) return;
        
        const packages = creative.packages?.items || [];
  
        packages.forEach((pkg) => {
            // Prioritize pricePerHour since we display "pro Stunde"
            const priceToCompare = typeof pkg.pricePerHour === "number" && pkg.pricePerHour > 0
                ? pkg.pricePerHour
                : typeof pkg.price === "number" && pkg.price > 0
                ? pkg.price
                : null;
            
            if (priceToCompare !== null && priceToCompare < lowestPrice) {
                lowestPrice = priceToCompare;
            }
        });
    });
  
    return lowestPrice === Infinity ? null : lowestPrice;
};